/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { HelpDocument } from '../models/HelpDocument';
import type { IActionResult } from '../models/IActionResult';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class HelpDocumentService {
  /**
   * @returns HelpDocument OK
   * @throws ApiError
   */
  public static getApiHelpDocument(): CancelablePromise<Array<HelpDocument>> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/HelpDocument',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        409: `Conflict`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * @param formData
   * @returns IActionResult OK
   * @throws ApiError
   */
  public static postApiHelpDocument(
    formData?: {
      Label?: string;
      File?: Blob;
    },
  ): CancelablePromise<IActionResult> {
    return __request(OpenAPI, {
      method: 'POST',
      url: '/api/HelpDocument',
      formData: formData,
      mediaType: 'multipart/form-data',
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        409: `Conflict`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * @param documentId
   * @returns HelpDocument OK
   * @throws ApiError
   */
  public static getApiHelpDocument1(
    documentId: string,
  ): CancelablePromise<HelpDocument> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/HelpDocument/{documentId}',
      path: {
        'documentId': documentId,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        409: `Conflict`,
        500: `Internal Server Error`,
      },
    });
  }
  /**
   * @param id
   * @returns IActionResult OK
   * @throws ApiError
   */
  public static deleteApiHelpDocument(
    id: string,
  ): CancelablePromise<IActionResult> {
    return __request(OpenAPI, {
      method: 'DELETE',
      url: '/api/HelpDocument/{id}',
      path: {
        'id': id,
      },
      errors: {
        400: `Bad Request`,
        401: `Unauthorized`,
        409: `Conflict`,
        500: `Internal Server Error`,
      },
    });
  }
}
